<template>
  <base-container style="height: 100%" ref="container">
    <el-tabs type="border-card" v-model="tabName" style="height: calc(100% - 7px)" tab-position="left">
      <el-tab-pane label="顺序规则" name="order" lazy>
        <OrderRule code="order" v-if="projects.length" :projects="projects"></OrderRule>
      </el-tab-pane>
      <el-tab-pane label="互斥规则" name="interval" lazy>
        <IntervalRule code="interval" v-if="projects.length" :projects="projects"></IntervalRule>
      </el-tab-pane>
      <!-- <el-tab-pane label="合并规则" name="merge" lazy>
        <MergeRule code="merge" v-if="projects.length" :projects="projects"></MergeRule>
      </el-tab-pane> -->
    </el-tabs>
  </base-container>
</template>

<script>
import IntervalRule from "./rules/IntervalRule.vue";
import OrderRule from "./rules/OrderRule.vue";
import { list } from "@/api/zl/project";
export default {
  components: { IntervalRule, OrderRule },
  data() {
    return {
      tabName: "order",
      projects: [],
    };
  },
  created() {
    list().then((res) => {
      this.projects = res.data.data;
    });
  },
};
</script>

<style scoped>
::v-deep .el-tabs__content {
  height: 100%;
  padding: 10px 0;
}

::v-deep .el-tab-pane {
  height: 100%;
}
</style>
